import { z } from 'zod';

import { CssColorSchema } from './CssValues';

export const CSS_VARIABLE_SCHEMAS = {
  '--aui-primary': CssColorSchema,
  '--aui-on-primary': CssColorSchema,
  '--aui-surface': CssColorSchema,
  '--aui-on-surface': CssColorSchema,
};

export type CssVariableName = keyof typeof CSS_VARIABLE_SCHEMAS;

export const CSS_VARIABLE_NAMES = Object.keys(CSS_VARIABLE_SCHEMAS) as CssVariableName[];

type CssVariableEntrySchemas = {
  [Name in CssVariableName]: z.ZodCatch<z.ZodOptional<(typeof CSS_VARIABLE_SCHEMAS)[Name]>>;
};

const cssVariableEntrySchemas = Object.fromEntries(
  CSS_VARIABLE_NAMES.map((name) => [name, CSS_VARIABLE_SCHEMAS[name].optional().catch(undefined)])
) as CssVariableEntrySchemas;

export const CssVariablesSchema = z.object(cssVariableEntrySchemas);
